import { TTableColumn } from '@treezor/design-system';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import {
  TCardTransactionRowType,
  TCardTransactionColumnKey,
} from '@/features/cards/store/models/card-transactions.model';

export function CardTransactionHeaders({ headersList }: { headersList: TCardTransactionColumnKey[] }) {
  const { t } = useTranslation();

  const getHeaderLabel = useCallback(
    (label: TCardTransactionColumnKey): string => {
      switch (label) {
        case 'cardtransactionId':
          return t('pages.currentProfiles.cards.transactions.table.headers.paymentMode');
        case 'mccCode':
          return t('pages.currentProfiles.cards.transactions.table.headers.mcc');
        case 'authorizationResponseCode':
          return t('pages.currentProfiles.cards.transactions.table.headers.authorization');
        case 'paymentAmount':
          return t('pages.currentProfiles.cards.transactions.table.headers.amount');
        case 'is3DS':
          return t('pages.currentProfiles.cards.transactions.table.headers.3DSecure');

        default:
          return t(`pages.currentProfiles.cards.transactions.table.headers.${label.toString()}`);
      }
    },
    [t],
  );

  return headersList.map(
    (field: keyof TCardTransactionRowType): TTableColumn<TCardTransactionRowType> => ({
      name: field,
      field,
      label: (
        <div className={`w-full text-nowrap ${['paymentAmount'].includes(field.toString()) ? 'flex justify-end' : ''}`}>
          {getHeaderLabel(field)}
        </div>
      ),
    }),
  );
}
